import React from 'react';
import block from 'bem-cn-lite';
import {Button} from '@yandex-data-ui/common';
import {HTML} from '@doc-tools/components';
import {ImageObjectProps, ImageProps} from '@yandex-data-ui/page-constructor';

import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';
import {QuoteProps as QuoteParams} from 'units/constructor-local/models';
import AuthorBlock, {AuthorBlockType} from 'components/AuthorBlock/AuthorBlock';
import Image from 'components/Image/Image';

import './Quote.scss';

const b = block('quote-block');

type QuoteProps = QuoteParams & WithTranslationProps;

class Quote extends React.Component<QuoteProps> {
    render() {
        const {theme, color, image, border = 'shadow'} = this.props;

        return (
            <div className={b({theme, border})} style={color ? {backgroundColor: color} : {}}>
                {this.renderCardContent()}
                {this.renderCardImage(image)}
            </div>
        );
    }

    private renderCardImage(image: ImageProps) {
        const imageData: ImageObjectProps = typeof image === 'string' ? {src: image} : image;

        return (
            <div className={b('image-wrapper')}>
                <Image src={imageData.src} alt={imageData.alt} className={b('image')} />
            </div>
        );
    }

    private renderCardContent() {
        const {text, logo} = this.props;

        return (
            <div key={text} className={b('content-wrapper')}>
                <div>
                    <img className={b('logo')} src={logo} />
                    <div className={b('content')}>
                        <span className={b('text')}>
                            <HTML>{text}</HTML>
                        </span>
                    </div>
                </div>
                {this.renderFooter()}
            </div>
        );
    }

    private renderFooter() {
        const {author, url, theme, i18nK} = this.props;

        return (
            Boolean(author || url) && (
                <div className={b('author-wrapper')}>
                    {author && (
                        <AuthorBlock
                            className={b('author', {theme})}
                            author={author}
                            type={AuthorBlockType.Line}
                        />
                    )}
                    {url && (
                        <Button
                            view="outlined"
                            size="xl"
                            href={url}
                            className={b('link-button', {theme})}
                        >
                            {i18nK('constructor_see_also')}
                        </Button>
                    )}
                </div>
            )
        );
    }
}

export default withTranslation('constructor')(Quote);
